unit UMenu1Form;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Math,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig, Types,
  Vcl.Grids, WEBLib.Grids, UStampModel, WEBLib.Buttons, WEBLib.Storage,
  UHistoryList, UVmPosList;

type
  TMenu1Form = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlMain: TPanel;
    pnlHistory: TPanel;
    pnlHistoryHeader: TPanel;
    pnlHistoryData: TPanel;
    sgHistory: TStringGrid;
    btnSwitchProject: TBitBtn;
    lblHistoryHeader: TLabel;
    btnAttachmentList: TBitBtn;
    btnStamp: TBitBtn;
    btnMenu: TBitBtn;
    pnlButtons: TPanel;
    btnFakLook: TBitBtn;
    btnClockEdit: TBitBtn;
    tmrClock: TTimer;
    lblTimePoint: TLabel;
    btnSwitchWork: TBitBtn;
    btnMaterialList: TBitBtn;
    btnMatLook: TBitBtn;
    btnLogout: TBitBtn;
    btnReportList: TBitBtn;
    btnRepLook: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    [ASync]
    procedure btnLogoutClick(Sender: TObject); async;
    [ASync]
    procedure btnSwitchProjectClick(Sender: TObject); async;
    [ASync]
    procedure btnAttachmentListClick(Sender: TObject); async;
    [ASync]
    procedure btnStampClick(Sender: TObject); async;
    [ASync]
    procedure btnMenuClick(Sender: TObject); async;
    [ASync]
    procedure btnFakLookClick(Sender: TObject); async;
    [ASync]
    procedure btnClockEditClick(Sender: TObject); async;
    procedure tmrClockTimer(Sender: TObject);
    [ASync]
    procedure btnSwitchWorkClick(Sender: TObject); async;
    [ASync]
    procedure btnMaterialListClick(Sender: TObject); async;
    [ASync]
    procedure btnMatLookClick(Sender: TObject); async;
    [ASync]
    procedure btnReportListClick(Sender: TObject); async;
    procedure sgHistoryDblClick(Sender: TObject);
    [ASync]
    procedure btnRepLookClick(Sender: TObject); async;
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FStamp: TStampModel;
    FFakStamp: TStampModel;
    FHistoryList: THistoryList;
    FTimePoint: TDateTime;
    FVmPosList: TVmPosList;
    procedure CreateTransfer(TermBuId: Integer; Stamp: TStampModel);
    procedure EnableButtons;
    procedure Error(Sender: TObject; AMsg: string);
    procedure GetLastStamps(Sender: TObject);
    procedure HandleListEmpty(Sender: TObject);
    procedure SgHistoryFill(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetHistoryList(const Value: THistoryList);
    procedure SetStamp(const Value: TStampModel);
    procedure SetTimePoint(const Value: TDateTime);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property HistoryList: THistoryList read FHistoryList write SetHistoryList;
    property Stamp: TStampModel read FStamp write SetStamp;
    property TimePoint: TDateTime read FTimePoint write SetTimePoint;
  protected procedure LoadDFMValues; override; end;

var
  Menu1Form: TMenu1Form;

implementation

uses
  UEssentialHelper, UGridHelper, UClockEditForm, UStampList,
  UAttachmentListForm, UTaetForm, UMaterialListForm, UReportListForm,
  UHistoryModel, UFakForm, UAttachmentList, UAttachmentModel, UTransferModel,
  UTransferList, UFakModel, UWebReportUtils, WEBLib.LocalFiles;

{$R *.dfm}
{ TMenu1Form }

procedure TMenu1Form.btnClockEditClick(Sender: TObject);
var
  frm: TClockEditForm;
begin
  Self.MainConfig.TimerReset;
  frm := TClockEditForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TClockEditForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  frm.TimePoint := Self.TimePoint;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
    if frm.ModalResult = mrOK then
    begin
      tmrClock.Enabled := false;
      tmrClock.Interval := 15000;
      Self.TimePoint := frm.TimePoint;
      tmrClock.Enabled := true;
    end;
  finally
    Self.Show;
    frm.Free;
  end;
end;

procedure TMenu1Form.btnFakLookClick(Sender: TObject);
var
  frm: TFakForm;
  frm1: TAttachmentListForm;
  Fak: TFakModel;
begin
  Self.MainConfig.TimerReset;
  pnlButtons.Visible := false;
  Fak := nil;
  frm := TFakForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TFakForm, frm.Load);
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
    frm.HideFak := FFakStamp.Fak;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
    Fak := frm.SelectedFak;
  finally
    Self.Show;
    frm.Free;
  end;
  if Fak <> nil then
  begin
    frm1 := TAttachmentListForm.Create(Self);
    frm1.Caption := Self.Caption;
    frm1.Popup := false;
    await(TAttachmentListForm, frm1.Load);
    frm1.MainConfig := Self.MainConfig;
    frm1.FakNr := Fak.Nr;
    frm1.Kind := akUnknown;
    frm1.EnableButtons(false);
    try
      Self.Hide;
      await(TModalResult, frm1.Execute);
    finally
      Self.Show;
      frm1.Free;
    end;
  end;
  Self.WebFormResize(Self);
end;

procedure TMenu1Form.btnLogoutClick(Sender: TObject);
begin
  Self.Close;
end;

procedure TMenu1Form.btnSwitchProjectClick(Sender: TObject);
var
  frm: TFakForm;
  frm1: TTaetForm;
  Stamp, Stamp1: TStampModel;
  geoLoc: TGeoLocation;
  procedure StampCallback(Sender: TObject);
  var
    st: TStampModel;
    id: Integer;
  begin
    if Sender is TStampModel then
    begin
      st := Sender as TStampModel;
      if st.Result.ResultValue then
      begin
        if st.Art = 'AE' then
        begin
          id := StrToInt(st.Result.ResultMessage);
          Self.CreateTransfer(id, st);
        end;
        Self.HistoryList.Add(THistoryModel.Create(st, now));
        if Stamp1 <> nil then
        begin
          Stamp1.Insert(Self.MainConfig.Uri);
          Stamp1 := nil;
        end;
      end
      else
      begin
        Self.HistoryList.Add(THistoryModel.Create(st));
        Self.Error(Sender, st.Result.ResultMessage);
      end;
    end;
  end;

  procedure HandleGeoLocation(Sender: TObject; Lat: Double; Lon: Double;
    Alt: Double);
  var
    s: string;
  begin
    s := FloatToStr(Lat);
    Stamp.Lat := StringReplace(s, ',', '.', [rfReplaceAll]);
    s := FloatToStr(Lon);
    Stamp.Lon := StringReplace(s, ',', '.', [rfReplaceAll]);
    Stamp1.Lat := Stamp.Lat;
    Stamp1.Lon := Stamp.Lon;
    Stamp.Insert(Self.MainConfig.Uri);
  end;

  procedure HandleGeoLocationError(Sender: TObject; ACode: UInt16;
    AMsg: string);
  begin
    Stamp.Insert(Self.MainConfig.Uri);
  end;

begin
  Self.MainConfig.TimerReset;
  if (Self.Stamp <> nil) and (Self.Stamp.Art = 'KO') then
  begin
    frm := TFakForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TFakForm, frm.Load);
    frm.HideFak := Self.FFakStamp.Fak;
    frm.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
      if (frm.SelectedFak <> nil) and (frm.SelectedFak.Bezeichnung <> '') then
      begin
        Stamp := TStampModel.Create;
        Stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
        Stamp.Art := 'AE';
        Stamp.Zeitpunkt := Self.TimePoint;
        if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) then
          Stamp.Fak := FFakStamp.Fak;
        Stamp.OnError := Self.Error;
        Stamp.OnPropertyChanged := StampCallback;
        Stamp1 := TStampModel.Create;
        Stamp1.PersonalNr := Self.MainConfig.User.PersonalNr;
        Stamp1.Art := 'AA';
        Stamp1.Zeitpunkt := Stamp.Zeitpunkt;
        Stamp1.Fak := frm.SelectedFak;
        Stamp1.OnError := Self.Error;
        Stamp1.OnPropertyChanged := StampCallback;
        frm1 := TTaetForm.Create(frm);
        frm1.Caption := frm.Caption;
        frm1.Popup := false;
        await(TTaetForm, frm1.Load);
        frm1.MainConfig := frm.MainConfig;
        try
          frm.Hide;
          await(TModalResult, frm1.Execute);
          if frm1.SelectedTaet <> nil then
            Stamp1.Taet := frm1.SelectedTaet;
        finally
          frm.Show;
          frm.WebFormResize(nil);
          frm1.Free;
        end;
        if (Stamp1.Taet <> nil) and (Stamp1.Taet.Bezeichnung <> '') then
        begin
          if Self.MainConfig.CommonConfig.GeoLoaction then
          begin
            geoLoc := TGeoLocation.Create(Self);
            geoLoc.OnGeolocation := HandleGeoLocation;
            geoLoc.OnGeolocationError := HandleGeoLocationError;
            if geoLoc.HasGeolocation then
              geoLoc.GetGeolocation
            else
              Stamp.Insert(Self.MainConfig.Uri);
          end
          else
            Stamp.Insert(Self.MainConfig.Uri);
        end;
      end;
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(nil);
    end;
  end;
end;

procedure TMenu1Form.btnSwitchWorkClick(Sender: TObject);
var
  frm1: TTaetForm;
  Stamp, Stamp1: TStampModel;
  geoLoc: TGeoLocation;
  procedure StampCallback(Sender: TObject);
  var
    st: TStampModel;
    id: Integer;
  begin
    if Sender is TStampModel then
    begin
      st := Sender as TStampModel;
      if st.Result.ResultValue then
      begin
        if st.Art = 'AE' then
        begin
          id := StrToInt(st.Result.ResultMessage);
          Self.CreateTransfer(id, st);
        end;
        Self.HistoryList.Add(THistoryModel.Create(st, now));
        if Stamp1 <> nil then
        begin
          Stamp1.Insert(Self.MainConfig.Uri);
          Stamp1 := nil;
        end;
      end
      else
      begin
        Self.HistoryList.Add(THistoryModel.Create(st));
        Self.Error(Sender, st.Result.ResultMessage);
      end;
    end;
  end;

  procedure HandleGeoLocation(Sender: TObject; Lat: Double; Lon: Double;
    Alt: Double);
  var
    s: string;
  begin
    s := FloatToStr(Lat);
    Stamp.Lat := StringReplace(s, ',', '.', [rfReplaceAll]);
    s := FloatToStr(Lon);
    Stamp.Lon := StringReplace(s, ',', '.', [rfReplaceAll]);
    Stamp1.Lat := Stamp.Lat;
    Stamp1.Lon := Stamp.Lon;
    Stamp.Insert(Self.MainConfig.Uri);
  end;

  procedure HandleGeoLocationError(Sender: TObject; ACode: UInt16;
    AMsg: string);
  begin
    Stamp.Insert(Self.MainConfig.Uri);
  end;

begin
  Self.MainConfig.TimerReset;
  if (Self.Stamp <> nil) and (Self.Stamp.Art = 'KO') then
  begin
    Stamp := TStampModel.Create;
    Stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
    Stamp.Art := 'AE';
    Stamp.Zeitpunkt := Self.TimePoint;
    if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) then
      Stamp.Fak := FFakStamp.Fak;
    Stamp.OnError := Self.Error;
    Stamp.OnPropertyChanged := StampCallback;
    Stamp1 := TStampModel.Create;
    Stamp1.PersonalNr := Self.MainConfig.User.PersonalNr;
    Stamp1.Art := 'AA';
    Stamp1.Zeitpunkt := Stamp.Zeitpunkt;
    Stamp1.Fak := Stamp.Fak;
    Stamp1.OnError := Self.Error;
    Stamp1.OnPropertyChanged := StampCallback;
    frm1 := TTaetForm.Create(Self);
    frm1.Caption := Self.Caption;
    frm1.Popup := false;
    await(TTaetForm, frm1.Load);
    frm1.HideTaet := Self.FFakStamp.Taet;
    frm1.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm1.Execute);
      if frm1.SelectedTaet <> nil then
        Stamp1.Taet := frm1.SelectedTaet;
    finally
      Self.Show;
      Self.WebFormResize(Self);
      frm1.Free;
    end;
    if (Stamp1.Taet <> nil) and (Stamp1.Taet.Bezeichnung <> '') and
      (Stamp1.Fak <> nil) and (Stamp1.Fak.Bezeichnung <> '') then
    begin
      if Self.MainConfig.CommonConfig.GeoLoaction then
      begin
        geoLoc := TGeoLocation.Create(Self);
        geoLoc.OnGeolocation := HandleGeoLocation;
        geoLoc.OnGeolocationError := HandleGeoLocationError;
        if geoLoc.HasGeolocation then
          geoLoc.GetGeolocation
        else
          Stamp.Insert(Self.MainConfig.Uri);
      end
      else
        Stamp.Insert(Self.MainConfig.Uri);
    end;
  end;
end;

procedure TMenu1Form.CreateTransfer(TermBuId: Integer; Stamp: TStampModel);
var
  lst: TAttachmentList;
  item: TAttachmentModel;
  i: Integer;
  rep: TReportList;
  rItem: TReport;
  tFile: TTextFile;
  procedure HandleFileExists(Sender: TObject; AValue: Boolean);
  var
    tItem: TReport;
  begin
    if AValue then
    begin
      Stamp.HasPdfs := true;
      tItem := rep.GetByPathAndFilename((Sender as TTextFile).Pathname,
        (Sender as TTextFile).FileName);
      if tItem <> nil then
      begin
        tItem.TransmittedAt := now;
        rep.Store;
        Self.MainConfig.TransferList.Add(TTransferModel.Create(tItem,
          TermBuId));
      end;
    end;
  end;

begin
  lst := TAttachmentList.Create;
  lst.FakNr := Stamp.Fak.Nr;
  lst.PersonalNr := Stamp.PersonalNr;
  lst.Kind := akUnknown;
  lst.Load;
  for i := 0 to lst.Count - 1 do
  begin
    item := lst.Items[i];
    if item.TransmittedAt = 0 then
    begin
      case item.Kind of
        akUnknown:
          ;
        akPicture:
          Stamp.HasPictures := true;
        akComment:
          Stamp.HasComments := true;
      end;
      Self.MainConfig.TransferList.Add(TTransferModel.Create(item, TermBuId));
      item.TransmittedAt := now;
    end;
  end;
  lst.Store;
  rep := TReportList.Create;
  rep.PersonalNr := Stamp.PersonalNr;
  rep.Fak := Stamp.Fak;
  rep.Load;
  for i := 0 to rep.Count - 1 do
  begin
    rItem := rep.Items[i];
    if (rItem.TransmittedAt = 0) and (rItem.PdfPathname <> '') and
      (rItem.PdfFilename <> '') then
    begin
      tFile := TTextFile.Create;
      tFile.OnFileExists := HandleFileExists;
      tFile.FileExists(rItem.PdfPathname, rItem.PdfFilename);
    end;
  end;
  FVmPosList := TVmPosList.Create;
  FVmPosList.Fak := Stamp.Fak;
  FVmPosList.Url := Self.MainConfig.Uri;
  FVmPosList.PersonalNr := Stamp.PersonalNr;
  FVmPosList.Load;
  FVmPosList.StartTransmit;
end;

procedure TMenu1Form.btnAttachmentListClick(Sender: TObject);
var
  frm: TAttachmentListForm;
begin
  Self.MainConfig.TimerReset;
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
  begin
    frm := TAttachmentListForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TAttachmentListForm, frm.Load);
    frm.Kind := akUnknown;
    frm.MainConfig := Self.MainConfig;
    frm.EnableButtons(true);
    frm.FakNr := Self.FFakStamp.Fak.Nr;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Self);
    end;
  end;
end;

procedure TMenu1Form.btnStampClick(Sender: TObject);
var
  frm: TFakForm;
  frm1: TTaetForm;
  Stamp, Stamp1: TStampModel;
  geoLoc: TGeoLocation;
  procedure StampCallback(Sender: TObject);
  var
    st: TStampModel;
    id: Integer;
  begin
    if Sender is TStampModel then
    begin
      st := Sender as TStampModel;
      if st.Result.ResultValue then
      begin
        if st.Art = 'AE' then
        begin
          id := StrToInt(st.Result.ResultMessage);
          Self.CreateTransfer(id, st);
          Self.SgHistoryFill(Self);
        end;
        Self.HistoryList.Add(THistoryModel.Create(st, now));
        if Stamp1 <> nil then
        begin
          Stamp1.Insert(Self.MainConfig.Uri);
          Stamp1 := nil;
        end;
      end
      else
      begin
        Self.HistoryList.Add(THistoryModel.Create(st));
        Self.Error(Sender, st.Result.ResultMessage);
      end;
    end;
  end;

  procedure HandleGeoLocation(Sender: TObject; Lat: Double; Lon: Double;
    Alt: Double);
  var
    s: string;
  begin
    s := FloatToStr(Lat);
    Stamp.Lat := StringReplace(s, ',', '.', [rfReplaceAll]);
    s := FloatToStr(Lon);
    Stamp.Lon := StringReplace(s, ',', '.', [rfReplaceAll]);
    Stamp1.Lat := Stamp.Lat;
    Stamp1.Lon := Stamp.Lon;
    Stamp.Insert(Self.MainConfig.Uri);
  end;

  procedure HandleGeoLocationError(Sender: TObject; ACode: UInt16;
    AMsg: string);
  begin
    Stamp.Insert(Self.MainConfig.Uri);
  end;

begin
  Self.MainConfig.TimerReset;
  if (Self.Stamp = nil) or (Self.Stamp.Art = 'GE') then
  begin
    frm := TFakForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TFakForm, frm.Load);
    frm.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
      if frm.SelectedFak <> nil then
      begin
        Stamp := TStampModel.Create;
        Stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
        Stamp.Art := 'KO';
        Stamp.Zeitpunkt := Self.TimePoint;
        Stamp.OnError := Self.Error;
        Stamp.OnPropertyChanged := StampCallback;
        Stamp1 := TStampModel.Create;
        Stamp1.PersonalNr := Self.MainConfig.User.PersonalNr;
        Stamp1.Art := 'AA';
        Stamp1.Zeitpunkt := Stamp.Zeitpunkt;
        Stamp1.Fak := frm.SelectedFak;
        Stamp1.OnError := Self.Error;
        Stamp1.OnPropertyChanged := StampCallback;
        frm1 := TTaetForm.Create(frm);
        frm1.Caption := Self.Caption;
        frm1.Popup := false;
        await(TTaetForm, frm1.Load);
        frm1.MainConfig := Self.MainConfig;
        try
          frm.Hide;
          await(TModalResult, frm1.Execute);
          if frm1.SelectedTaet <> nil then
            Stamp1.Taet := frm1.SelectedTaet;
        finally
          frm.Show;
          frm1.Free;
        end;
        if Stamp1.Taet <> nil then
        begin
          if Self.MainConfig.CommonConfig.GeoLoaction then
          begin
            geoLoc := TGeoLocation.Create(Self);
            geoLoc.OnGeolocation := HandleGeoLocation;
            geoLoc.OnGeolocationError := HandleGeoLocationError;
            if geoLoc.HasGeolocation then
              geoLoc.GetGeolocation
            else
              Stamp.Insert(Self.MainConfig.Uri);
          end
          else
            Stamp.Insert(Self.MainConfig.Uri);
        end;
      end;
    finally
      frm.Free;
      Self.Show;
    end;
  end
  else if (Self.Stamp <> nil) and (Self.Stamp.Art = 'KO') then
  begin
    Stamp := TStampModel.Create;
    Stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
    Stamp.Art := 'AE';
    Stamp.Zeitpunkt := Self.TimePoint;
    if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
    then
      Stamp.Fak := FFakStamp.Fak;
    Stamp.OnError := Self.Error;
    Stamp.OnPropertyChanged := StampCallback;
    Stamp1 := TStampModel.Create;
    Stamp1.PersonalNr := Self.MainConfig.User.PersonalNr;
    Stamp1.Art := 'GE';
    Stamp1.Zeitpunkt := Stamp.Zeitpunkt;
    Stamp1.OnError := Self.Error;
    Stamp1.OnPropertyChanged := StampCallback;
    if Self.MainConfig.CommonConfig.GeoLoaction then
    begin
      geoLoc := TGeoLocation.Create(Self);
      geoLoc.OnGeolocation := HandleGeoLocation;
      if geoLoc.HasGeolocation then
        geoLoc.GetGeolocation
      else
        Stamp.Insert(Self.MainConfig.Uri);
    end
    else
      Stamp.Insert(Self.MainConfig.Uri);
  end;
end;

procedure TMenu1Form.EnableButtons;
begin
  if (Self.Stamp = nil) or (Self.Stamp.Art = 'GE') then
  begin
    btnStamp.GlyphURL := 'Images\IconKo.png';
    btnStamp.Hint := 'Kommen';
    btnSwitchProject.Visible := false;
    btnAttachmentList.Visible := false;
    btnSwitchWork.Visible := false;
    btnMaterialList.Visible := false;
    btnReportList.Visible := false;
  end
  else
  begin
    btnStamp.GlyphURL := 'Images\IconGe.png';
    btnStamp.Hint := 'Gehen';
    btnSwitchProject.Visible := true;
    btnAttachmentList.Visible := true;
    btnSwitchWork.Visible := true;
    btnMaterialList.Visible := true;
    btnReportList.Visible := true;
  end;
end;

procedure TMenu1Form.Error(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOk], nil);
end;

procedure TMenu1Form.GetLastStamps(Sender: TObject);
var
  lst: TStampList;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampList then
      Self.HistoryList.Merge(Sender as TStampList);
    Self.SgHistoryFill(Sender);
  end;

begin
  lst := TStampList.Create;
  lst.OnError := Self.Error;
  lst.OnPropertyChanged := Callback;
  lst.GetLastStamps(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.OverviewConfig.StampsCount, saWithoutVM);
end;

procedure TMenu1Form.HandleListEmpty(Sender: TObject);
begin
  MessageDLG('Alle Daten wurden übertragen.', mtInformation, [mbOk], nil);
end;

procedure TMenu1Form.SetHistoryList(const Value: THistoryList);
begin
  FHistoryList := Value;
end;

procedure TMenu1Form.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.HistoryList := THistoryList.Create(Self.MainConfig);
  Self.HistoryList.OnListChanged := Self.SgHistoryFill;
  Self.GetLastStamps(Self);
  Self.MainConfig.TransferList.OnListChanged := Self.HandleListEmpty;
end;

procedure TMenu1Form.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
  Self.EnableButtons;
end;

procedure TMenu1Form.SetTimePoint(const Value: TDateTime);
begin
  FTimePoint := Value;
  lblTimePoint.Caption := FormatDateTime('ddd dd.mm.yy hh:nn:ss', Value);
end;

procedure TMenu1Form.sgHistoryDblClick(Sender: TObject);
begin
  if (0 < sgHistory.Row) and (sgHistory.Row <= Self.HistoryList.Count) then
  begin
    Self.HistoryList.Delete(sgHistory.Row - 1);
    Self.SgHistoryFill(Sender);
  end;
end;

procedure TMenu1Form.SgHistoryFill(Sender: TObject);
var
  i: Integer;
  item: THistoryModel;
begin
  sgHistory.DefaultRowHeight := 32;
  sgHistory.ColCount := 11;
  sgHistory.RowCount := Self.HistoryList.Count + 1;
  sgHistory.FixedCols := 0;
  sgHistory.FixedRows := 1;
  sgHistory.ColWidths[0] := 5;
  sgHistory.ColWidths[1] := 24;
  sgHistory.ColWidths[2] := 90;
  sgHistory.ColWidths[3] := 32;
  sgHistory.ColWidths[4] := 16;
  sgHistory.ColWidths[5] := 16;
  sgHistory.ColWidths[6] := 16;
  sgHistory.ColWidths[7] := 5;
  sgHistory.ColWidths[8] := 150;
  sgHistory.ColWidths[9] := 5;
  sgHistory.ColWidths[10] := 100;
  sgHistory.Cells[2, 0] := Bold('Zeitpunkt');
  sgHistory.Cells[3, 0] := Bold('Art');
  sgHistory.Cells[8, 0] := Bold('Auftrag');
  sgHistory.Cells[10, 0] := Bold('Tätigkeit');
  for i := 0 to Self.HistoryList.Count - 1 do
  begin
    item := Self.HistoryList.Items[i];
    if item.Transmitted then
      sgHistory.Cells[1, i + 1] :=
        '<img src="Images\IconOk.png" style="width:16px;height:16px;">'
    else
      sgHistory.Cells[1, i + 1] := '';
    case item.Kind of
      mkUnknown:
        begin
          sgHistory.Cells[2, i + 1] := '';
          sgHistory.Cells[3, i + 1] := '';
          sgHistory.Cells[4, i + 1] := '';
          sgHistory.Cells[5, i + 1] := '';
          sgHistory.Cells[6, i + 1] := '';
          sgHistory.Cells[7, i + 1] := '';
          sgHistory.Cells[8, i + 1] := '';
          sgHistory.Cells[9, i + 1] := '';
          sgHistory.Cells[10, i + 1] := '';
        end;
      mkStamp:
        begin
          sgHistory.Cells[2, i + 1] := FormatDateTime('dd.mm.yy hh:nn',
            item.Stamp.Zeitpunkt);
          sgHistory.Cells[3, i + 1] := item.Stamp.Art;
          if item.Stamp.HasComments then
            sgHistory.Cells[4, i + 1] :=
              '<img src="Images\IconComment.png" style="width:16px;height:16px;">'
          else
            sgHistory.Cells[4, i + 1] := '';
          if item.Stamp.HasPictures then
            sgHistory.Cells[5, i + 1] :=
              '<img src="Images\Iconpicture.png" style="width:16px;height:16px;">'
          else
            sgHistory.Cells[5, i + 1] := '';
          if item.Stamp.HasPdfs then
            sgHistory.Cells[6, i + 1] :=
              '<img src="Images\IconPdf.png" style="width:16px;height:16px;">'
          else
            sgHistory.Cells[6, i + 1] := '';
          if item.Stamp.Fak <> nil then
            sgHistory.Cells[8, i + 1] := item.Stamp.Fak.ToString
          else
            sgHistory.Cells[8, i + 1] := '';
          if item.Stamp.Taet <> nil then
            sgHistory.Cells[10, i + 1] := item.Stamp.Taet.ToString
          else
            sgHistory.Cells[10, i + 1] := '';
        end;
      mkPicture:
        begin

        end;
    end;
  end;
  Stamp := Self.HistoryList.GetLastStamp;
  FFakStamp := Self.HistoryList.GetLastFakStamp;
  Self.WebFormResize(Self);
end;

procedure TMenu1Form.tmrClockTimer(Sender: TObject);
begin
  if tmrClock.Interval <> 1000 then
    tmrClock.Interval := 1000;
  Self.TimePoint := now;
end;

procedure TMenu1Form.btnMaterialListClick(Sender: TObject);
var
  frm: TMaterialListForm;
begin
  Self.MainConfig.TimerReset;
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
  begin
    frm := TMaterialListForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TMaterialListForm, frm.Load);
    frm.Fak := FFakStamp.Fak;
    frm.MainConfig := Self.MainConfig;
    frm.EnableButtons(true);
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Self);
    end;
  end;
end;

procedure TMenu1Form.btnMatLookClick(Sender: TObject);
var
  frm: TFakForm;
  frm1: TMaterialListForm;
  Fak: TFakModel;
begin
  Self.MainConfig.TimerReset;
  pnlButtons.Visible := false;
  Fak := nil;
  frm := TFakForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TFakForm, frm.Load);
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
    frm.HideFak := FFakStamp.Fak;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
    Fak := frm.SelectedFak;
  finally
    Self.Show;
    frm.Free;
  end;
  if Fak <> nil then
  begin
    frm1 := TMaterialListForm.Create(Self);
    frm1.Caption := Self.Caption;
    frm1.Popup := false;
    await(TMaterialListForm, frm1.Load);
    frm1.Fak := Fak;
    frm1.MainConfig := Self.MainConfig;
    frm1.EnableButtons(false);
    try
      Self.Hide;
      await(TModalResult, frm1.Execute);
    finally
      Self.Show;
      frm1.Free;
    end;
  end;
  Self.WebFormResize(Self);
end;

procedure TMenu1Form.btnMenuClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  pnlButtons.Visible := not pnlButtons.Visible;
  Self.WebFormResize(Self);
end;

procedure TMenu1Form.btnRepLookClick(Sender: TObject);
var
  frm: TFakForm;
  frm1: TReportListForm;
  Fak: TFakModel;
begin
  Self.MainConfig.TimerReset;
  pnlButtons.Visible := false;
  Fak := nil;
  frm := TFakForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TFakForm, frm.Load);
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
    frm.HideFak := FFakStamp.Fak;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
    Fak := frm.SelectedFak;
  finally
    Self.Show;
    frm.Free;
  end;
  if Fak <> nil then
  begin
    frm1 := TReportListForm.Create(Self);
    frm1.Caption := Self.Caption;
    frm1.Popup := false;
    await(TReportListForm, frm1.Load);
    frm1.ButtonsEnabled := false;
    frm1.MainConfig := Self.MainConfig;
    frm1.Fak := Fak;
    try
      Self.Hide;
      await(TModalResult, frm1.Execute);
    finally
      Self.Show;
      frm1.Free;
    end;
  end;
  Self.WebFormResize(Self);
end;

procedure TMenu1Form.btnReportListClick(Sender: TObject);
var
  frm: TReportListForm;
begin
  Self.MainConfig.TimerReset;
  if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) and (FFakStamp.Fak.Nr <> '')
  then
  begin
    frm := TReportListForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TReportListForm, frm.Load);
    frm.MainConfig := Self.MainConfig;
    frm.ButtonsEnabled := true;
    frm.Fak := FFakStamp.Fak;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Self);
    end;
  end;
end;

procedure TMenu1Form.WebFormCreate(Sender: TObject);
begin
  Stamp := nil;
  FFakStamp := nil;
  Self.HistoryList := nil;
end;

procedure TMenu1Form.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TMenu1Form.WebFormResize(Sender: TObject);
var
  w: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    lblTimePoint.Top := 8;
    pnlFooter.Visible := false;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
    if pnlButtons.Visible then
      pnlHistory.Height := Self.ClientHeight - pnlHeader.Height -
        pnlStatus.Height - pnlMain.Height - pnlButtons.Height
    else
      pnlHistory.Height := Self.ClientHeight - pnlHeader.Height -
        pnlStatus.Height - pnlMain.Height;
  end
  else
  begin
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    lblTimePoint.Top := 24;
    pnlFooter.Visible := true;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
    if pnlButtons.Visible then
      pnlHistory.Height := Self.ClientHeight - pnlHeader.Height -
        pnlStatus.Height - pnlMain.Height - pnlFooter.Height - pnlButtons.Height
    else
      pnlHistory.Height := Self.ClientHeight - pnlHeader.Height -
        pnlStatus.Height - pnlMain.Height - pnlFooter.Height;
  end;
  pnlHeader.Width := Self.Width;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlMain.Top := pnlStatus.Top + pnlStatus.Height;
  pnlButtons.Top := pnlMain.Top + pnlMain.Height;
  if pnlButtons.Visible then
    pnlHistory.Top := pnlButtons.Top + pnlButtons.Height
  else
    pnlHistory.Top := pnlMain.Top + pnlMain.Height;
  pnlMain.Width := Min(535, Self.ClientWidth);
  w := Self.ClientWidth - pnlMain.Width;
  if w <= 0 then
    w := 0;
  w := w div 2;
  pnlMain.Left := w;
  pnlButtons.Left := w;
  pnlButtons.Width := pnlMain.Width;
  pnlHistory.Left := w;
  pnlHistory.Width := pnlMain.Width;
  btnLogout.Left := pnlButtons.ClientWidth - btnLogout.Width - 6;
  btnMenu.Left := pnlMain.ClientWidth - btnMenu.Width - 6;
end;

procedure TMenu1Form.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  lblTimePoint := TLabel.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlMain := TPanel.Create(Self);
  btnSwitchProject := TBitBtn.Create(Self);
  btnAttachmentList := TBitBtn.Create(Self);
  btnStamp := TBitBtn.Create(Self);
  btnMenu := TBitBtn.Create(Self);
  btnSwitchWork := TBitBtn.Create(Self);
  btnMaterialList := TBitBtn.Create(Self);
  btnReportList := TBitBtn.Create(Self);
  pnlHistory := TPanel.Create(Self);
  pnlHistoryHeader := TPanel.Create(Self);
  lblHistoryHeader := TLabel.Create(Self);
  pnlHistoryData := TPanel.Create(Self);
  sgHistory := TStringGrid.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnFakLook := TBitBtn.Create(Self);
  btnClockEdit := TBitBtn.Create(Self);
  btnMatLook := TBitBtn.Create(Self);
  btnLogout := TBitBtn.Create(Self);
  btnRepLook := TBitBtn.Create(Self);
  tmrClock := TTimer.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  lblTimePoint.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlMain.BeforeLoadDFMValues;
  btnSwitchProject.BeforeLoadDFMValues;
  btnAttachmentList.BeforeLoadDFMValues;
  btnStamp.BeforeLoadDFMValues;
  btnMenu.BeforeLoadDFMValues;
  btnSwitchWork.BeforeLoadDFMValues;
  btnMaterialList.BeforeLoadDFMValues;
  btnReportList.BeforeLoadDFMValues;
  pnlHistory.BeforeLoadDFMValues;
  pnlHistoryHeader.BeforeLoadDFMValues;
  lblHistoryHeader.BeforeLoadDFMValues;
  pnlHistoryData.BeforeLoadDFMValues;
  sgHistory.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnFakLook.BeforeLoadDFMValues;
  btnClockEdit.BeforeLoadDFMValues;
  btnMatLook.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  btnRepLook.BeforeLoadDFMValues;
  tmrClock.BeforeLoadDFMValues;
  try
    Name := 'Menu1Form';
    Width := 640;
    Height := 625;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UMenu1Form.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    lblTimePoint.SetParentComponent(pnlHeader);
    lblTimePoint.Name := 'lblTimePoint';
    lblTimePoint.Left := 8;
    lblTimePoint.Top := 24;
    lblTimePoint.Width := 3;
    lblTimePoint.Height := 15;
    lblTimePoint.HeightPercent := 100.000000000000000000;
    lblTimePoint.WidthPercent := 100.000000000000000000;
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 601;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 3;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 4;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 8;
    pnlMain.Top := 98;
    pnlMain.Width := 466;
    pnlMain.Height := 48;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 3;
    pnlMain.ShowCaption := False;
    btnSwitchProject.SetParentComponent(pnlMain);
    btnSwitchProject.Name := 'btnSwitchProject';
    btnSwitchProject.Tag := 1;
    btnSwitchProject.Left := 48;
    btnSwitchProject.Top := 4;
    btnSwitchProject.Width := 40;
    btnSwitchProject.Height := 40;
    btnSwitchProject.Hint := 'Projekt wechseln';
    btnSwitchProject.Color := clNone;
    btnSwitchProject.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnSwitchProject.Glyph.png');
    btnSwitchProject.GlyphSize := 32;
    btnSwitchProject.HeightPercent := 100.000000000000000000;
    btnSwitchProject.ShowHint := True;
    btnSwitchProject.WidthPercent := 100.000000000000000000;
    SetEvent(btnSwitchProject, Self, 'OnClick', 'btnSwitchProjectClick');
    btnAttachmentList.SetParentComponent(pnlMain);
    btnAttachmentList.Name := 'btnAttachmentList';
    btnAttachmentList.Left := 136;
    btnAttachmentList.Top := 4;
    btnAttachmentList.Width := 40;
    btnAttachmentList.Height := 40;
    btnAttachmentList.Hint := 'Anhangliste';
    btnAttachmentList.Color := clNone;
    btnAttachmentList.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnAttachmentList.Glyph.png');
    btnAttachmentList.GlyphSize := 32;
    btnAttachmentList.HeightPercent := 100.000000000000000000;
    btnAttachmentList.ShowHint := True;
    btnAttachmentList.WidthPercent := 100.000000000000000000;
    SetEvent(btnAttachmentList, Self, 'OnClick', 'btnAttachmentListClick');
    btnStamp.SetParentComponent(pnlMain);
    btnStamp.Name := 'btnStamp';
    btnStamp.Left := 4;
    btnStamp.Top := 4;
    btnStamp.Width := 40;
    btnStamp.Height := 40;
    btnStamp.Color := clNone;
    btnStamp.GlyphSize := 32;
    btnStamp.HeightPercent := 100.000000000000000000;
    btnStamp.ShowHint := True;
    btnStamp.WidthPercent := 100.000000000000000000;
    SetEvent(btnStamp, Self, 'OnClick', 'btnStampClick');
    btnMenu.SetParentComponent(pnlMain);
    btnMenu.Name := 'btnMenu';
    btnMenu.Tag := 1;
    btnMenu.Left := 379;
    btnMenu.Top := 4;
    btnMenu.Width := 40;
    btnMenu.Height := 40;
    btnMenu.Hint := 'erweitertes Men'#252;
    btnMenu.Color := clNone;
    btnMenu.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnMenu.Glyph.png');
    btnMenu.GlyphSize := 32;
    btnMenu.HeightPercent := 100.000000000000000000;
    btnMenu.ShowHint := True;
    btnMenu.WidthPercent := 100.000000000000000000;
    SetEvent(btnMenu, Self, 'OnClick', 'btnMenuClick');
    btnSwitchWork.SetParentComponent(pnlMain);
    btnSwitchWork.Name := 'btnSwitchWork';
    btnSwitchWork.Left := 92;
    btnSwitchWork.Top := 4;
    btnSwitchWork.Width := 40;
    btnSwitchWork.Height := 40;
    btnSwitchWork.Hint := 'T'#228'tigkeit wechseln';
    btnSwitchWork.Color := clNone;
    btnSwitchWork.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnSwitchWork.Glyph.png');
    btnSwitchWork.GlyphSize := 32;
    btnSwitchWork.HeightPercent := 100.000000000000000000;
    btnSwitchWork.ShowHint := True;
    btnSwitchWork.WidthPercent := 100.000000000000000000;
    SetEvent(btnSwitchWork, Self, 'OnClick', 'btnSwitchWorkClick');
    btnMaterialList.SetParentComponent(pnlMain);
    btnMaterialList.Name := 'btnMaterialList';
    btnMaterialList.Left := 180;
    btnMaterialList.Top := 4;
    btnMaterialList.Width := 40;
    btnMaterialList.Height := 40;
    btnMaterialList.Hint := 'Materialliste';
    btnMaterialList.Color := clNone;
    btnMaterialList.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnMaterialList.Glyph.png');
    btnMaterialList.GlyphSize := 32;
    btnMaterialList.HeightPercent := 100.000000000000000000;
    btnMaterialList.ShowHint := True;
    btnMaterialList.WidthPercent := 100.000000000000000000;
    SetEvent(btnMaterialList, Self, 'OnClick', 'btnMaterialListClick');
    btnReportList.SetParentComponent(pnlMain);
    btnReportList.Name := 'btnReportList';
    btnReportList.Left := 224;
    btnReportList.Top := 4;
    btnReportList.Width := 40;
    btnReportList.Height := 40;
    btnReportList.Hint := 'Berichte';
    btnReportList.Color := clNone;
    btnReportList.Glyph.LoadFromFile('UMenu1Form.pnlMain.btnReportList.Glyph.png');
    btnReportList.GlyphSize := 32;
    btnReportList.HeightPercent := 100.000000000000000000;
    btnReportList.ShowHint := True;
    btnReportList.WidthPercent := 100.000000000000000000;
    SetEvent(btnReportList, Self, 'OnClick', 'btnReportListClick');
    pnlHistory.SetParentComponent(Self);
    pnlHistory.Name := 'pnlHistory';
    pnlHistory.Left := 8;
    pnlHistory.Top := 240;
    pnlHistory.Width := 466;
    pnlHistory.Height := 282;
    pnlHistory.Caption := 'pnlHistory';
    pnlHistory.ChildOrder := 4;
    pnlHistory.ShowCaption := False;
    pnlHistoryHeader.SetParentComponent(pnlHistory);
    pnlHistoryHeader.Name := 'pnlHistoryHeader';
    pnlHistoryHeader.Left := 0;
    pnlHistoryHeader.Top := 0;
    pnlHistoryHeader.Width := 466;
    pnlHistoryHeader.Height := 29;
    pnlHistoryHeader.Align := alTop;
    pnlHistoryHeader.Alignment := taLeftJustify;
    pnlHistoryHeader.Font.Charset := ANSI_CHARSET;
    pnlHistoryHeader.Font.Color := clNavy;
    pnlHistoryHeader.Font.Height := -16;
    pnlHistoryHeader.Font.Name := 'Segoe UI Semibold';
    pnlHistoryHeader.Font.Style := [fsBold,fsItalic];
    pnlHistoryHeader.ParentFont := False;
    lblHistoryHeader.SetParentComponent(pnlHistoryHeader);
    lblHistoryHeader.Name := 'lblHistoryHeader';
    lblHistoryHeader.Left := 4;
    lblHistoryHeader.Top := 4;
    lblHistoryHeader.Width := 58;
    lblHistoryHeader.Height := 21;
    lblHistoryHeader.Caption := 'Historie';
    lblHistoryHeader.HeightPercent := 100.000000000000000000;
    lblHistoryHeader.WidthPercent := 100.000000000000000000;
    pnlHistoryData.SetParentComponent(pnlHistory);
    pnlHistoryData.Name := 'pnlHistoryData';
    pnlHistoryData.Left := 0;
    pnlHistoryData.Top := 29;
    pnlHistoryData.Width := 466;
    pnlHistoryData.Height := 253;
    pnlHistoryData.Align := alClient;
    pnlHistoryData.Caption := 'pnlHistoryData';
    pnlHistoryData.ChildOrder := 1;
    pnlHistoryData.ShowCaption := False;
    sgHistory.SetParentComponent(pnlHistoryData);
    sgHistory.Name := 'sgHistory';
    sgHistory.Left := 0;
    sgHistory.Top := 0;
    sgHistory.Width := 466;
    sgHistory.Height := 253;
    sgHistory.Align := alClient;
    sgHistory.ColCount := 4;
    sgHistory.FixedCols := 0;
    sgHistory.RowCount := 2;
    sgHistory.Options := [goFixedHorzLine,goHorzLine,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgHistory.TabOrder := 0;
    SetEvent(sgHistory, Self, 'OnDblClick', 'sgHistoryDblClick');
    sgHistory.RangeEdit.Max := 100.000000000000000000;
    sgHistory.RangeEdit.Step := 1.000000000000000000;
    sgHistory.HeightPercent := 100.000000000000000000;
    sgHistory.WidthPercent := 100.000000000000000000;
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 8;
    pnlButtons.Top := 168;
    pnlButtons.Width := 466;
    pnlButtons.Height := 32;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 5;
    pnlButtons.ShowCaption := False;
    pnlButtons.Visible := False;
    btnFakLook.SetParentComponent(pnlButtons);
    btnFakLook.Name := 'btnFakLook';
    btnFakLook.Left := 4;
    btnFakLook.Top := 4;
    btnFakLook.Width := 24;
    btnFakLook.Height := 24;
    btnFakLook.Hint := 'Anh'#228'nge eines anderen Projekts ansehen';
    btnFakLook.Color := clNone;
    btnFakLook.Glyph.LoadFromFile('UMenu1Form.pnlButtons.btnFakLook.Glyph.png');
    btnFakLook.GlyphSize := 16;
    btnFakLook.HeightPercent := 100.000000000000000000;
    btnFakLook.ShowHint := True;
    btnFakLook.WidthPercent := 100.000000000000000000;
    SetEvent(btnFakLook, Self, 'OnClick', 'btnFakLookClick');
    btnClockEdit.SetParentComponent(pnlButtons);
    btnClockEdit.Name := 'btnClockEdit';
    btnClockEdit.Left := 88;
    btnClockEdit.Top := 4;
    btnClockEdit.Width := 24;
    btnClockEdit.Height := 24;
    btnClockEdit.Hint := 'Zeitpunkt '#228'ndern';
    btnClockEdit.Color := clNone;
    btnClockEdit.Glyph.LoadFromFile('UMenu1Form.pnlButtons.btnClockEdit.Glyph.png');
    btnClockEdit.GlyphSize := 16;
    btnClockEdit.HeightPercent := 100.000000000000000000;
    btnClockEdit.ShowHint := True;
    btnClockEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnClockEdit, Self, 'OnClick', 'btnClockEditClick');
    btnMatLook.SetParentComponent(pnlButtons);
    btnMatLook.Name := 'btnMatLook';
    btnMatLook.Left := 32;
    btnMatLook.Top := 4;
    btnMatLook.Width := 24;
    btnMatLook.Height := 24;
    btnMatLook.Hint := 'Materialien eines anderen Projekts ansehen';
    btnMatLook.Color := clNone;
    btnMatLook.Glyph.LoadFromFile('UMenu1Form.pnlButtons.btnMatLook.Glyph.png');
    btnMatLook.GlyphSize := 16;
    btnMatLook.HeightPercent := 100.000000000000000000;
    btnMatLook.ShowHint := True;
    btnMatLook.WidthPercent := 100.000000000000000000;
    SetEvent(btnMatLook, Self, 'OnClick', 'btnMatLookClick');
    btnLogout.SetParentComponent(pnlButtons);
    btnLogout.Name := 'btnLogout';
    btnLogout.Tag := 1;
    btnLogout.Left := 422;
    btnLogout.Top := 4;
    btnLogout.Width := 24;
    btnLogout.Height := 24;
    btnLogout.Hint := 'Abmelden';
    btnLogout.Color := clNone;
    btnLogout.Glyph.LoadFromFile('UMenu1Form.pnlButtons.btnLogout.Glyph.png');
    btnLogout.GlyphSize := 16;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.ShowHint := True;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    btnRepLook.SetParentComponent(pnlButtons);
    btnRepLook.Name := 'btnRepLook';
    btnRepLook.Left := 60;
    btnRepLook.Top := 4;
    btnRepLook.Width := 24;
    btnRepLook.Height := 24;
    btnRepLook.Hint := 'Berichte eines anderen Projekts ansehen';
    btnRepLook.Color := clNone;
    btnRepLook.Glyph.LoadFromFile('UMenu1Form.pnlButtons.btnRepLook.Glyph.png');
    btnRepLook.GlyphSize := 16;
    btnRepLook.HeightPercent := 100.000000000000000000;
    btnRepLook.ShowHint := True;
    btnRepLook.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepLook, Self, 'OnClick', 'btnRepLookClick');
    tmrClock.SetParentComponent(Self);
    tmrClock.Name := 'tmrClock';
    SetEvent(tmrClock, Self, 'OnTimer', 'tmrClockTimer');
    tmrClock.Left := 528;
    tmrClock.Top := 544;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    lblTimePoint.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlMain.AfterLoadDFMValues;
    btnSwitchProject.AfterLoadDFMValues;
    btnAttachmentList.AfterLoadDFMValues;
    btnStamp.AfterLoadDFMValues;
    btnMenu.AfterLoadDFMValues;
    btnSwitchWork.AfterLoadDFMValues;
    btnMaterialList.AfterLoadDFMValues;
    btnReportList.AfterLoadDFMValues;
    pnlHistory.AfterLoadDFMValues;
    pnlHistoryHeader.AfterLoadDFMValues;
    lblHistoryHeader.AfterLoadDFMValues;
    pnlHistoryData.AfterLoadDFMValues;
    sgHistory.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnFakLook.AfterLoadDFMValues;
    btnClockEdit.AfterLoadDFMValues;
    btnMatLook.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    btnRepLook.AfterLoadDFMValues;
    tmrClock.AfterLoadDFMValues;
  end;
end;

end.
